import { Component, OnInit, Output, EventEmitter, ViewChild, TemplateRef } from "@angular/core";
import { environment } from "src/environments/environment";
import { MatTableDataSource } from "@angular/material/table";
import { HttpClient } from "@angular/common/http";
import { MatDialog } from "@angular/material/dialog";
import { QuotingToolService } from "../../quoting-tool.service";
import { NotificationService } from "src/app/core/services/notification.service";
import { UploadEBOM } from "src/app/core/interfaces/quoting-tool";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { saveAs } from 'file-saver';
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import * as XLSX from 'xlsx';
import { NgbModal, NgbModalConfig } from "@ng-bootstrap/ng-bootstrap";

export interface Row {
  id: number;
  category: string;
  description: string;
  designator: string;
  footprint: string;
  manufacturer: string;
  mpn: any;
  quantity: number;
  isEdit: boolean;
  mpnError?: boolean; // Error state for MPN
  quantityError?: boolean; // Error state for Total Required
}

@Component({
  selector: "app-bom-upload",
  templateUrl: "./bom-upload.component.html"
})
export class BomUploadComponent implements OnInit {

  @Output() nextStep = new EventEmitter<void>();
  imagePath = environment.image_path;
  getImagePath: any = environment.image_path;
  getFilePath: any = environment.file_path;
  loading: boolean = false;
  nextButtonLoading: boolean = false;
  editId: number | null = null;


  @ViewChild('mapColumnBOM', { static: true }) mapColumnBOM!: TemplateRef<any>;

  mapColumnBOMModal:any;
  mapColumnBOMForm!:FormGroup;
  selectedFile: any = null;
  mapDone:boolean=false;
  extractedColumnList:any=[];

  displayedColumns: string[] = [
    'id',
    'category',
    'description',
    'designator',
    'footprint',
    'manufacturer',
    'mpn',
    'quantity',
    'actions'
  ];
  dataSource = new MatTableDataSource<Row>();
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  
  rows: Row[] = [];
  originalRows: { [key: number]: Row } = {}; // Store original row data
  projectID: any;

  //mapColumn
  displayedColumnsmapBOM: string[] = ['vRapidiseHeader','FileHeader'];
  dataSourcemapBOM!: MatTableDataSource<any>;
  bomColumnData:any=[
    {vRapidiseHeader:'Serial Number',vFormControlName:'SrNo',required:false},
    {vRapidiseHeader:'Category',vFormControlName:'vComponentCategory',required:false},
    {vRapidiseHeader:'Description',vFormControlName:'vPartDescription',required:false},
    {vRapidiseHeader:'Designator',vFormControlName:'vDesignator',required:false},
    {vRapidiseHeader:'Footprint',vFormControlName:'vFootprint',required:false},
    {vRapidiseHeader:'Manufacturer',vFormControlName:'vManufacturer',required:false},
    {vRapidiseHeader:'MPN',vFormControlName:'vMPN',required:true},
    {vRapidiseHeader:'Quantity',vFormControlName:'iQuantity',required:true}
  ];
 
  @ViewChild('paginatorBOMMapColumn') paginatorBOMMapColumn!: MatPaginator;

  constructor(
    private modalService: NgbModal,
    config: NgbModalConfig,
    private http: HttpClient, 
    public dialog: MatDialog, 
    private quotingService: QuotingToolService, 
    private notificationService: NotificationService, 
    private ngxLoader: NgxUiLoaderService
    ) { 
      config.backdrop = "static";
      config.keyboard = false;
    }


  ngOnInit(): void {

    this.projectID = localStorage.getItem('projectID');
    this.dataSourcemapBOM = new MatTableDataSource(this.bomColumnData);

    // this.fetchData();
    this.GetEbomTableData();
  }

  ngOnDestroy(){
    this.modalService.dismissAll();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  hasError(form: FormGroup,controlName: string, errorName: string): boolean {
    const control = form.get(controlName);
    return !!control?.hasError(errorName) && (!!control?.touched);
  }
  
  getRowIndex(index: number): number {
    return this.paginator ? index + 1 + this.paginator.pageIndex * this.paginator.pageSize : index + 1;
  }
  
  onEdit(id: number) {
    this.editId = id;
  }

  onSave(id: number) {
    this.editId = null;
  }

  onDelete(id: number) {
    this.rows = this.rows.filter(row => row.id !== id);
  }

  isEditing(rowId: number): boolean {
    return this.editId === rowId;
  }

  handleApiResponse(response: any): void {
    if (response) {
      const data = response.map((item: any) => this.mapApiDataToRow(item));
      this.rows = data;
      this.dataSource.data = this.rows;
    } else {
    }
  }

  handleApiError(error: any): void {
  }
  uniqueIdCounter = 0;
  mapApiDataToRow(item: any): Row {
    return {
      id: this.generateUniqueId(),
      category: item['Category'],
      description: item['Description'],
      designator: item['Designator'],
      footprint: item['Footprint'],
      manufacturer: item['Manufacturer'],
      mpn: item['MPN'],
      quantity: item['Quantity'] ? Number(item['Quantity']) : 0, // Ensure default value is a number
      isEdit: false, // Set isEdit to false by default
      mpnError: false,
      quantityError: false,
    };
  }

  generateUniqueId(): number {
    return ++this.uniqueIdCounter;  // Increment and return the unique ID
  }

  addRow(): void {
    const newRow: Row = {
      id: this.rows.length + 1,
      category: '',
      description: '',
      designator: '',
      footprint: '',
      manufacturer: '',
      mpn: '',
      quantity: 0,
      isEdit: true,
      mpnError: false,
      quantityError: false,
    };
    this.rows.push(newRow);
    this.dataSource.data = [...this.rows];
  }

  editRow(row: Row): void {
    this.originalRows[row.id] = { ...row }; // Save original row data
    row.isEdit = true;
    row.mpnError = false;
    row.quantityError = false;
  }

  saveRow(row: Row): void {
    const isValid = this.validateRow(row);
    row.mpnError = !isValid.mpnValid;
    row.quantityError = !isValid.quantityValid;

    if (isValid.mpnValid && isValid.quantityValid) {
      row.isEdit = false;
      delete this.originalRows[row.id]; // Clear original row data after saving
    }
  }

  cancelEdit(row: Row): void {
    const originalRow = this.originalRows[row.id];
    if (originalRow) {
      Object.assign(row, originalRow); // Revert to original data
      row.isEdit = false;
      delete this.originalRows[row.id]; // Clear original row data after cancelling
    } else {
      // If the row is new and empty, remove it
      this.rows = this.rows.filter(r => r.id !== row.id);
      this.dataSource.data = this.rows;
    }
  }

  deleteRow(id: number): void {
    this.rows = this.rows.filter((row) => row.id !== id);
    this.dataSource.data = this.rows;
  }

  onFieldChange(row: Row, field: keyof Row, value: string): void {
    if (typeof value === 'string') {
      value = value.replace(/\s/g, ''); // Remove all spaces
    }
  
    if (field === 'quantity') {
      row.quantity = parseFloat(value) || 0;
    } else {
      (row as any)[field] = value;
    }
  
    this.validateRow(row);
  }
  

  validateRow(row: Row): { mpnValid: boolean; quantityValid: boolean } {
    const mpnValid = (typeof row.mpn === 'string' && row.mpn.trim() !== '') || (typeof row.mpn === 'number');
    const quantityValid = typeof row.quantity === 'number' && row.quantity > 0;
    row.mpnError = !mpnValid || (typeof row.mpn === 'string' && row.mpn.trim() === '');
    row.quantityError = !quantityValid;
    return { mpnValid, quantityValid };
  }

  // submitTable(): void {
  //   let hasInvalidRow = false;
  //   this.rows.forEach((row) => {
  //     const isValid = this.validateRow(row);
  //     if (!isValid.mpnValid || !isValid.quantityValid) {
  //       hasInvalidRow = true;
  //     }
  //   });

  //   if (hasInvalidRow) {
  //     alert(
  //       'Please make sure you have entered the "MPN" and "Quantity" fields correctly.'
  //     );
  //     console.log(
  //       'Invalid rows:',
  //       this.rows.filter((row) => row.mpnError || row.quantityError)
  //     );
  //     return;
  //   }

  //   this.nextButtonLoading = true;

  //   let tableData = {
  //     projectId: this.projectID,
  //     projectType: 1,
  //     data: this.rows.map((row, index) => ({
  //       "Sr. No.": row.id,
  //       "Category": row.category,
  //       "Description": row.description,
  //       "Designator": row.designator,
  //       "Footprint": row.footprint,
  //       "Manufacturer": row.manufacturer,
  //       "MPN": row.mpn,
  //       "Quantity": row.quantity,
  //     }))
  //   };
  //   console.log('Table Data:', tableData);

  //   this.quotingService
  //     .postEbomTableData(tableData)
  //     .subscribe((resJSON: any) => {
  //       if (resJSON.code == 200) {
  //         this.notificationService.showSuccess(`${resJSON.message}`, "");
  //         const newValue = Math.random() * 100;
  //         this.quotingService.updateStepper(newValue);
  //       } else {
  //         this.notificationService.showError(`${resJSON.message}`, "");
  //       }
  //       this.nextButtonLoading = false;
  //     });
  // }

  private isModalOpen = false; // Track modal state

  submitBOMFile() {
      let hasInvalidRow = false;
      this.rows.forEach((row) => {
        const isValid = this.validateRow(row);
        if (!isValid.mpnValid || !isValid.quantityValid) {
          hasInvalidRow = true;
        }
      });

      if (hasInvalidRow) {
        alert(
          'Please make sure you have entered the "MPN" and "Quantity" fields correctly.'
        );
        console.log(
          'Invalid rows:',
          this.rows.filter((row) => row.mpnError || row.quantityError)
        );
        return;
      }

      // this.nextButtonLoading = true;

      let tableData = {
        projectId: this.projectID,
        projectType: 1,
        data: this.rows.map((row, index) => ({
          "Sr. No.": row.id,
          "Category": row.category,
          "Description": row.description,
          "Designator": row.designator,
          "Footprint": row.footprint,
          "Manufacturer": row.manufacturer,
          "MPN": row.mpn,
          "Quantity": row.quantity,
        }))
      };

      this.quotingService
        .postEbomTableData(tableData)
        .subscribe((resJSON: any) => {
          if (resJSON.code == 200) {
            this.nextStep.emit();
            this.notificationService.showSuccess(`${resJSON.message}`, "");
            const newValue = Math.random() * 100;
            this.quotingService.updateStepper(newValue);
          } else {
            this.notificationService.showError(`${resJSON.message}`, "");
          }
          this.nextButtonLoading = false;
        });
    // }
  }

  GetEbomTableData() {
    this.quotingService
      .GetEbomTableData(this.projectID)
      .subscribe(async (resJSON: any) => {
        if (resJSON.code == 200) {
          this.handleApiResponse(resJSON.data)
          this.notificationService.showSuccess(`${resJSON.message}`, "");
        }
      });
  }

  UploadEbomExcel(file: File | null) {
    if (!file) {
      return;
    }
    this.selectedFile=file;
    if(!this.mapDone){
      this.mapColumnBOMModal = this.modalService.open(this.mapColumnBOM, { centered: true, windowClass: "mileStone-modal", size: 'md' });
      return;
    }
  }


  createFormData(body: UploadEBOM): FormData {
    const formData = new FormData();
    if (body) {
      formData.append('vProjectID', body.vProjectID);
      formData.append('vProjectType', body.vProjectType!.toString());
      formData.append('vEBOMexcelFile', body.vEBOMexcelFile!, body.vEBOMexcelFile!.name);
    
      formData.append('header_Sr_No', this.mapColumnBOMForm.value.SrNo);
      formData.append('header_vComponentCategory', this.mapColumnBOMForm.value.vComponentCategory);
      formData.append('header_vMPN', this.mapColumnBOMForm.value.vMPN);
      formData.append('header_vPartDescription', this.mapColumnBOMForm.value.vPartDescription);
      formData.append('header_vManufacturer', this.mapColumnBOMForm.value.vManufacturer);
      formData.append('header_vFootprint', this.mapColumnBOMForm.value.vFootprint);
      formData.append('header_iQuantity', this.mapColumnBOMForm.value.iQuantity);
      formData.append('header_vDesignator', this.mapColumnBOMForm.value.vDesignator);
      return formData;
    }
    else {
      throw new Error('Unsupported type:');
    }
  }

  OpenMapColumModal(){
    this.dataSourcemapBOM.data=this.bomColumnData;
    this.dataSourcemapBOM.paginator = this.paginatorBOMMapColumn;
    this.mapColumnBOMModal = this.modalService.open(this.mapColumnBOM, { centered: true, windowClass: "mileStone-modal", size: 'md' });
  }
  
  CloseMapModal(){
    this.mapColumnBOMModal.close();
  }
  
  MapColumnAndUploadFile(){
    if(this.mapColumnBOMForm.invalid){
      this.mapColumnBOMForm.markAllAsTouched();
      return;
    }
    this.mapDone=true;
    this.loading = true;
    const reqJSON: UploadEBOM = {
      vProjectID: this.projectID,
      vProjectType: 1,
      vEBOMexcelFile: this.selectedFile
    };

    this.quotingService.UploadEbomExcel(this.createFormData(reqJSON))
      .subscribe(async (resJSON: any) => {
        // this.loading = true;
        if (resJSON.code == 200) {
          this.mapColumnBOMModal.close();
          this.handleApiResponse(resJSON.data.jsonData)
          this.notificationService.showSuccess(`${resJSON.message}`, "");
        }
        else {
          this.notificationService.showError(`${resJSON.message}`, "");
        }
        // this.loading = false;
      })
  }

  onFileSelected(event: Event, fileType: string) {
    const input = event.target as HTMLInputElement;
    if (input && input.files && input.files.length > 0) {
      const file: File = input.files[0];
      this.selectedFile = file
      if (this.selectedFile) {    
        if (this.selectedFile.name.endsWith('.csv') || this.selectedFile.name.endsWith('.xlsx') || this.selectedFile.name.endsWith('xls')) {
          this.mapDone=false;
          // R&D
          const reader = new FileReader();
    
          reader.onload = (event: any) => {
            const data = event.target.result;
    
            // Read file content as workbook
            const workbook = XLSX.read(data, { type: 'binary' });
    
            // Get the first sheet
            const firstSheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[firstSheetName];
    
            // Convert the worksheet to JSON and extract headers
            const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
            const headers = jsonData[0]; // The first row contains the headers
    
            this.extractedColumnList = headers;
            // END
        this.mapColumnsReset();
        this.UploadEbomExcel(this.selectedFile);
        }
        reader.readAsBinaryString(this.selectedFile);

        }
        else {         
          this.selectedFile = null; // Reset if invalid file is selected
          this.notificationService.showError('Please upload a CSV or Excel file.'); // Notify the user
        }
      }
      
    }else {
      this.selectedFile = null;
    }
    input.value='';
  }

  downloadExcelFile(): void {
    this.loading = true; // Set loading state to true
    const fileName = 'Rapidise Sample BoM Format.xlsx'; // File name
    const excelFileUrl = `${this.getFilePath}${fileName}`; // Concatenate file path and name

    // Use HttpClient to fetch the Excel file
    this.http.get(excelFileUrl, { responseType: 'blob' }).subscribe((blob:any) => {
      saveAs(blob, 'EBOM_Template.xlsx'); // Use file-saver to save the file
      this.loading = false; // Reset loading state
    }, (error:any) => {
      this.loading = false; // Reset loading state in case of error
    });
  }

  mapColumnsReset(){
    this.mapColumnBOMForm = new FormGroup({
      SrNo: new FormControl('S.No'),
      vComponentCategory: new FormControl('Category'),
      vMPN: new FormControl('Manufacturer Part Number', [Validators.required]),
      vPartDescription: new FormControl('Description'),
      vManufacturer: new FormControl('Manufacturer'),
      vDesignator: new FormControl('Designator'),
      vFootprint: new FormControl('Footprint (Optional)'),
      iQuantity: new FormControl('Quantity', [Validators.required]), 
    });
    Object.keys(this.mapColumnBOMForm.value).forEach((key:any)=>{
      const findHeader = this.extractedColumnList.find((column_header:any)=>this.mapColumnBOMForm.value[key]==column_header)
      if(findHeader){
        // Do Nothing
      }else{
        this.mapColumnBOMForm.controls[key].setValue('');
      }
    })
  }


}